"use client"
import React from "react"
import Link from "next/link"
import dynamic from "next/dynamic"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"

const MarkdownTooltip = dynamic(() => import('./MarkdownTooltip')) as any
const MarkdownListItem = dynamic(() => import('./MarkdownListItem')) as any

interface ContentMarkdownProps {
    locale: string
    content?: any
}

const ContentMarkdown: React.FC<ContentMarkdownProps> = ({content}) => {

    // console.log(`debug:content-markdown`,content)
    return (
        <ReactMarkdown
            components={{
                a: ({href, children}: any) => {
                    const external = /http/.test(href)

                    return (
                        <Link href={external ? href : `/${href.split(",").join("/")}/`} passHref
                              target={external ? '_blank' : '_self'}
                        >
                            {children}
                        </Link>
                    );
                },
                // @ts-ignore
                li: (props) => {
                    const {children} = props;

                    const isIncludedHref = children.filter((item: any) => typeof item?.props?.href !== "undefined")?.length !== 0

                    if (isIncludedHref) {
                        return children.map(({props}: any) => {
                            const {href, children} = props || {};

                            if (href) {
                                const external = /http/.test(href)

                                return (
                                    <li key={href}>
                                        <Link href={external ? href : `/${href.split(",").join("/")}/`} passHref
                                              target={external ? '_blank' : '_self'}
                                        >
                                            {children}
                                        </Link>
                                    </li>
                                )
                            }
                        })
                    }

                    return <MarkdownListItem {...props} />
                },
                i: (props: any) => {
                    switch (undefined) {
                        case props.explaination:
                            return (<i className={props.className}>{props.children}</i>)
                        default:
                            return (<MarkdownTooltip {...props} />)
                    }
                }
            }}
            rehypePlugins={[rehypeRaw]}
        >
            {content}
        </ReactMarkdown>
    )
}

export default ContentMarkdown